import { useContext } from 'react';
import { SessionContext } from '@/providers/SessionProvider';
import { isPlayfulTheme } from '@/lib/layout-version';

// Perfis de gestão institucional — mesma lista de usePlayfulNav.js:6
// (SIDEBAR_PROFILES) e do MANAGEMENT_PROFILES em menu-admin.jsx:20.
const ADMIN_PROFILES = ['Administrador', '4 secretariado', 'Tutor', 'Designer Institucional'];

// Espelha usePlayfulStudent(), trocando o perfil-alvo de Aluno para Professor.
// Responde "posso renderizar UI lúdica de CONTEÚDO (mascote, cores, copy) para
// este professor?" — não confundir com usePlayfulNav(), que só decide bottom
// bar vs sidebar e já vale true para professor independente desta regra.
//
// Sem sessão (tela pública ou fora do provider) vale o tema do tenant. Lê o
// SessionContext direto (sem throw) para não exigir provider em testes de
// unidade — ausência de provider ≡ sem sessão. Resolução last-match-wins igual
// à do useAuthorityLevel/usePlayfulStudent/usePlayfulNav.
export default function usePlayfulTeacher() {
  const context = useContext(SessionContext);
  const user = context?.session?.user;

  if (!isPlayfulTheme()) return false;
  if (!user) return true;

  const profiles = user.profileNames || user['profile-names'] || [];
  let level = '';
  profiles.forEach(profile => {
    if (ADMIN_PROFILES.includes(profile)) {
      level = 'admin';
    } else if (profile === 'Professor') {
      level = 'professor';
    }
  });

  return level === 'professor';
}
